import update from "immutability-helper";
import { v4 as uuidv4 } from "uuid";
import { get, forEach } from "lodash";
import {
  RESET_TABS,
  ADD_TAB,
  SAVE_TAB_DATA,
  REMOVE_TAB,
  CHANGE_TAB_ZONE,
  REQUEST_LOGS_TAB,
  RECEIVE_LOGS_TAB,
  RECEIVE_LOGS_TAB_OLD,
  FAILED_LOGS_TAB,
  SORT_LOGS_TAB,
  FILTER_LOGS_TAB,
  ADD_LATEST_LOG_TAB,
  RESET_TAB_LOGS,
  UPDATE_LOG_TAB,
  UPDATE_LOG_DATA,
  UPDATE_LOG_SELECTED_RAILCAR_ID,
  UPDATE_LOG_SELECTED_UNIT_ID,
  SET_LOGS_PAGE,
  SET_LOGS_ROWS_PER_PAGE,
  SET_DETECTION,
  SET_MAIN_NOTES,
  SET_COLLAPSED,
  UPDATE_FILTERED_LOGS,
  UPDATE_FILTERS,
} from "../../constants/actionTypes";

const defaultTab = {
  logs: {
    collapsed: {
      main: true,
      verified: {},
    },
  },
  liveEvents: {},
};

const tabs = (state = [], action) => {
  // console.log('tabs reducer', action);
  let existingTabs = [...state];
  switch (action.type) {
    case RESET_TABS:
      return [];
    case ADD_TAB:
      let newTab = { ...defaultTab, ...action.newTab, id: uuidv4() };
      forEach(action.removeTabs, (t) => {
        existingTabs = update(existingTabs, { $splice: [[t, 1]] });
      });
      // Insert tab at the specified index
      if (action.index) {
        return update(existingTabs, { $splice: [[action.index, 0, newTab]] });
      }
      // Insert tab at the end
      return [...existingTabs, newTab];
    case REMOVE_TAB:
      if (action.index >= 0 && action.index < state.length) {
        return update(state, { $splice: [[action.index, 1]] });
      }
      return state;
    case CHANGE_TAB_ZONE:
      return update(state, {
        [action.index]: {
          logs: { $set: {} },
          zone: { $set: action.zone },
          title: { $set: action.zone.name },
        },
      });
    case REQUEST_LOGS_TAB:
      return update(state, {
        [action.index]: {
          logs: {
            isFetching: { $set: true },
            error: { $set: null },
          },
        },
      });
    case RECEIVE_LOGS_TAB_OLD:
      if (get(state, [action.index])) {
        return update(state, {
          [action.index]: {
            logs: {
              isFetching: { $set: false },
              logs: state[action.index].logs.logs
                ? {
                    $set: mergeArrays(
                      state[action.index].logs.logs,
                      action.logs
                    ),
                  }
                : { $set: action.logs },
              filteredLogs: state[action.index].logs.filteredLogs
                ? {
                    $set: mergeArrays(
                      state[action.index].logs.filteredLogs,
                      action.filteredLogs
                    ),
                  }
                : { $set: action.filteredLogs },
              filters: { $set: action.filters },
              total: { $set: action.total },
              offset: state[action.index].logs.offset
                ? { $set: action.offset + state[action.index].logs.offset }
                : { $set: action.offset },
              sort: { $set: action.sort },
              pageNb: state[action.index].logs.pageNb
                ? { $set: state[action.index].logs.pageNb }
                : { $set: 0 },
              rowsPerPage: state[action.index].logs.rowsPerPage
                ? { $set: state[action.index].logs.rowsPerPage }
                : { $set: action.offset },
              error: { $set: null },
            },
          },
        });
      }
      return state;
    case RECEIVE_LOGS_TAB:
      return update(state, {
        [action.index]: {
          logs: {
            isFetching: { $set: false },
            logs: { $set: action.logs },
            filteredLogs: { $set: action.filteredLogs },
            filters: { $set: action.filters },
            total: { $set: action.total },
            offset: state[action.index].logs.offset
              ? { $set: action.offset + state[action.index].logs.offset }
              : { $set: action.offset },
            sort: { $set: action.sort },
            pageNb: { $set: action.pageNb || 0 },
            rowsPerPage: state[action.index].logs.rowsPerPage
              ? { $set: state[action.index].logs.rowsPerPage }
              : { $set: action.offset },
            error: { $set: null },
          },
        },
      });
    case FAILED_LOGS_TAB:
      if (get(state, [action.index, "logs"])) {
        return update(state, {
          [action.index]: {
            logs: {
              error: { $set: action.payload },
            },
          },
        });
      }
      return state;
    case UPDATE_FILTERS:
      return update(state, {
        [action.index]: {
          filters: { $set: action.filters },
        },
      });
    case SORT_LOGS_TAB:
      return update(state, {
        [action.index]: {
          logs: {
            filteredLogs: { $set: action.payload.filteredLogs },
            sort: { $set: action.payload.sort },
          },
        },
      });
    case FILTER_LOGS_TAB:
      return update(state, {
        [action.index]: {
          logs: {
            pageNb: { $set: 0 },
            filteredLogs: { $set: action.payload.filteredLogs },
            filters: {
              [action.payload.field]: {
                [action.payload.subField]: { $set: action.payload.filter },
              },
            },
          },
        },
      });
    case UPDATE_FILTERED_LOGS:
      return update(state, {
        [action.index]: {
          logs: {
            filteredLogs: { $set: action.filteredLogs },
          },
        },
      });
    case ADD_LATEST_LOG_TAB:
      return update(state, {
        [action.index]: {
          logs: {
            logs: {
              $set: mergeArrays(action.payload, state[action.index].logs.logs),
            },
            filteredLogs: {
              $set: mergeArrays(
                action.payload,
                state[action.index].logs.filteredLogs
              ),
            },
            offset: { $set: state[action.index].offset + 1 },
          },
        },
      });
    case RESET_TAB_LOGS:
      return update(state, {
        [action.index]: {
          logs: {
            logs: { $set: {} },
            filteredLogs: { $set: null },
          },
        },
      });
    case UPDATE_LOG_TAB:
      if (action.replaceIndex) {
        return update(state, {
          [action.index]: {
            logs: {
              logs: { $splice: [[action.replaceIndex, 1, action.eventGroup]] },
              filteredLogs: {
                $splice: [[action.replaceIndex, 1, action.eventGroup]],
              },
              filters: { $set: action.filters },
            },
          },
        });
      }
      return state;
    case UPDATE_LOG_DATA:
      return update(state, {
        [action.index]: {
          data: { $set: action.eventGroup },
        },
      });
    case UPDATE_LOG_SELECTED_RAILCAR_ID:
      if (action.dynamicTabIndex) {
        if (existingTabs[action.dynamicTabIndex].selectedRailcarId) {
          return update(state, {
            [action.dynamicTabIndex]: {
              selectedRailcarId: { $set: action.selectedRailcarId },
            },
          });
        }
        existingTabs[action.dynamicTabIndex].selectedRailcarId = action.selectedRailcarId;
        return existingTabs;
      }
      return state;
    case UPDATE_LOG_SELECTED_UNIT_ID:
      if (action.dynamicTabIndex) {
        if (existingTabs[action.dynamicTabIndex].selectedUnitId) {
          return update(state, {
            [action.dynamicTabIndex]: {
              selectedUnitId: { $set: action.selectedUnitId },
            },
          });
        }
        existingTabs[action.dynamicTabIndex].selectedUnitId = action.selectedUnitId;
        return existingTabs;
      }
      return state;
    case SAVE_TAB_DATA:
      return update(state, {
        $splice: [[action.index, 1, action.tab]],
      });
    case SET_LOGS_PAGE:
      return update(state, {
        [action.index]: {
          logs: {
            pageNb: { $set: action.pageNb },
          },
        },
      });
    case SET_LOGS_ROWS_PER_PAGE:
      return update(state, {
        [action.index]: {
          logs: {
            rowsPerPage: { $set: action.rowsNb },
          },
        },
      });
    case SET_DETECTION:
      return update(state, {
        [action.index]: {
          data: { $merge: { detection: action.detection } },
        },
      });
    case SET_MAIN_NOTES:
      return update(state, {
        [action.index]: {
          data: { $merge: { mainNotes: action.mainNotes } },
        },
      });
    case SET_COLLAPSED:
      return update(state, {
        0: {
          logs: {
            collapsed: { $set: action.payload },
          },
        },
      });
    default:
      return state;
  }
};

export default tabs;

const mergeArrays = (arr2, arr1) => {
  let res = [];
  if (arr1) {
    res = [...arr1];
  }
  if (arr2) {
    arr2.forEach((item2) => {
      let exists = false;
      res.forEach((item1) => {
        if (item2.id === item1.id) {
          exists = true;
        }
      });
      if (!exists) {
        res.push(item2);
      }
    });
  }
  res.sort((a, b) => get(b, ["id"]) - get(a, ["id"]));
  return res;
};
